import {
  OriginEnum,
  ProjectDocumentsApi,
  ProjectFilesApi,
} from "@socotec.io/document-sdk";
import { config } from "@/setup/openApiConfig";

const documentApi = new ProjectDocumentsApi(config);
const projectFilesApi = new ProjectFilesApi(config);

const DEFAULT_MIME_TYPE = "application/octet-stream";

export const DocumentUploadClient = {
  createStoredDocument: async ({ form, file, projectUuid }) => {
    const intent = await projectFilesApi.presignUploadUrl({
      relatedObjectPk: projectUuid,
      presignUrlUploadRequest: {
        contentType: file.type || DEFAULT_MIME_TYPE,
      },
    });

    const stored = await fetch(intent.url, {
      method: "PUT",
      headers: intent.headers,
      body: file,
    });
    if (!stored.ok) {
      throw new Error(
        `File upload to storage failed with HTTP ${stored.status}`
      );
    }

    return documentApi.create({
      relatedObjectPk: projectUuid,
      documentCreate: {
        ...form,
        name: form.name || file.name,
        uuid: intent.uuid,
        origin: OriginEnum.ObjectStorage,
      },
    });
  },
};
